import { useEffect, useState } from 'react';

export function canCloseReceipt(user) {
  return user?.role === 'FINANCE' || user?.role === 'ADMIN';
}

export function isTouchLayout() {
  if (typeof window === 'undefined') return false;
  const hasCoarsePointer =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches;
  return window.innerWidth < 1024 || hasCoarsePointer;
}

export function useTouchLayout() {
  const [touchLayout, setTouchLayout] = useState(isTouchLayout);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const coarsePointer =
      typeof window.matchMedia === 'function'
        ? window.matchMedia('(pointer: coarse)')
        : null;
    const update = () => setTouchLayout(isTouchLayout());

    window.addEventListener('resize', update);
    if (coarsePointer?.addEventListener) {
      coarsePointer.addEventListener('change', update);
    } else {
      coarsePointer?.addListener?.(update);
    }
    update();

    return () => {
      window.removeEventListener('resize', update);
      if (coarsePointer?.removeEventListener) {
        coarsePointer.removeEventListener('change', update);
      } else {
        coarsePointer?.removeListener?.(update);
      }
    };
  }, []);

  return touchLayout;
}

export function useVisualViewportHeight() {
  const [viewport, setViewport] = useState(() => ({
    height: typeof window === 'undefined' ? null : window.visualViewport?.height ?? null,
    offsetTop: typeof window === 'undefined' ? null : window.visualViewport?.offsetTop ?? null,
  }));

  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return undefined;

    const visualViewport = window.visualViewport;
    const update = () => {
      const height = visualViewport.height ?? null;
      const offsetTop = visualViewport.offsetTop ?? null;
      setViewport((current) =>
        current.height === height && current.offsetTop === offsetTop
          ? current
          : { height, offsetTop },
      );
    };
    visualViewport.addEventListener('resize', update);
    visualViewport.addEventListener('scroll', update);
    update();

    return () => {
      visualViewport.removeEventListener('resize', update);
      visualViewport.removeEventListener('scroll', update);
    };
  }, []);

  return viewport.height;
}
